import CreatePaymentType from '../../../../../../component/systemMaster/sponsorBank/sponsorBankPayment/paymentType/createPaymentType/createPaymentType'

const CreatePaymentTypes=()=>{
    return <CreatePaymentType/>
}
export default CreatePaymentTypes